import { AppRoute } from '@/modules/settings/types'
import {
  DashboardHomePage,
  UserCompaniesPage,
  UserProfilePage,
} from './pages';
import { CreatorPage } from '../creator/CreatorPage';
import { HOME_ROUTES } from './routes-typed'

export const homeRoutesMap : Record<string, string> = {
  creator: HOME_ROUTES.creator.path,
  dashboard: HOME_ROUTES.dashboard.path,
  userProfile: HOME_ROUTES.userProfile.path,
  userCompanies: HOME_ROUTES.userCompanies.path,
}

export const homeRoutes: AppRoute[] = [
  {
    path: homeRoutesMap.creator,
    component: CreatorPage,
  },
  {
    path: homeRoutesMap.dashboard,
    component: DashboardHomePage,
  },
  {
    path: homeRoutesMap.userProfile,
    component: UserProfilePage,
  },
  {
    path: homeRoutesMap.userCompanies,
    component: UserCompaniesPage,
  },
];
